/* Storefront analytics only. Email contact capture never changes subscription consent. */
(function () {
  'use strict';
  if (window.self !== window.top || window.SoftPuraAnalytics) return;
  var configNode = document.getElementById('sp-posthog-config');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
  if (!config.enabled || !/^phc_[a-zA-Z0-9_-]+$/.test(config.token || '')) return;
  if (!/^https:\/\/(eu|us)\.i\.posthog\.com\/?$/.test(config.host || '')) return;
  var params = new URLSearchParams(window.location.search);
  var preview = config.preview || config.designMode || params.has('preview_theme_id') ||
    !/^(www\.)?softpura\.com$/.test(window.location.hostname);
  var test = config.testEnabled === true && params.get('sp_ph_test') === '1';
  if (preview && !test) return;
  var environment = test ? 'test' : 'production';
  var BRIDGE = 'sp_ph_bridge_v1';
  var FINGERPRINT = 'sp_ph_contact_fingerprint_v1';
  var sdk = null;
  var loading = false;
  var active = false;
  var identifiedFingerprint = null;
  var epoch = 0;
  var identifying = Promise.resolve();
  var pending = [];
  var pendingContacts = [];
  var windowId = null;
  var suppressBridge = false;
  var allowedEvents = /^(popup_(viewed|hair_selected|hair_straight|hair_wavy|hair_curly|email_started|submitted|closed|error)|storefront_checkout_clicked|product_viewed|cart_added|contact_captured|subscription_(requested|accepted|failed|confirmed|request_accepted|request_failed)|tracking_ready)$/;
  var allowedProps = /^(source|provider|status|reason|product_id|variant_id|quantity|value|currency|path|consent_state|request_id|popup_[a-z_]+|error_code)$/;

  function consent() {
    try {
      var choice = window.localStorage.getItem('sp_cookie_consent');
      var analyticsAllowed = choice === 'all';
      if (!analyticsAllowed && choice) {
        try {
          var parsed = JSON.parse(choice);
          analyticsAllowed = !!parsed && typeof parsed === 'object' && !Array.isArray(parsed) && parsed.analytics === true;
        } catch (error) { analyticsAllowed = false; }
      }
      return analyticsAllowed &&
        window.Shopify && window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (error) { return false; }
  }
  function cleanUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      var keep = new URLSearchParams();
      url.searchParams.forEach(function (v, k) {
        if (/^(utm_(source|medium|campaign|term|content|id)|campaign_id|ad_id|fbclid|gclid)$/.test(k) &&
            !/@|%40/i.test(v)) keep.set(k, v.slice(0, 300));
      });
      var path = url.pathname.replace(/[^/\s]*@[^/\s]*/g, '[redacted]')
        .replace(/\/(checkouts|reset|activate|recover|auth|oauth|token)(?:\/.*)?$/i, '/$1/[redacted]');
      return url.origin + path + (keep.toString() ? '?' + keep : '');
    } catch (error) { return ''; }
  }
  function clean(value, key, identify) {
    if (Array.isArray(value)) return value.map(function (v) { return clean(v, key, false); });
    if (value && typeof value === 'object') {
      var result = {};
      Object.keys(value).forEach(function (k) {
        if (/email|phone|password|token|authorization|cookie|address|name$/i.test(k) &&
            !(identify && k === 'email')) return;
        result[k] = clean(value[k], k, identify && (k === '$set' || k === 'email'));
      });
      return result;
    }
    if (typeof value === 'string') {
      if (identify && key === 'email') return value;
      if (/^https?:\/\//.test(value)) return cleanUrl(value);
      if (/@|%40/i.test(value)) return '[redacted]';
      return value.slice(0, 1000);
    }
    return value;
  }
  function beforeSend(event) {
    if (!active || !consent()) return null;
    var projectToken = event.properties && event.properties.token;
    if (event.properties) delete event.properties.email;
    // Replay data is SDK-encoded; traversing/truncating it corrupts recordings.
    // Replay has its own input/element protections and is disabled on private-URL pages.
    if (event.event !== '$snapshot') event.properties = clean(event.properties || {}, '', event.event === '$identify' || event.event === '$set');
    else {
      event.properties = event.properties || {};
      ['$current_url', '$referrer', '$initial_current_url', '$session_entry_url'].forEach(function (key) {
        if (typeof event.properties[key] === 'string') event.properties[key] = cleanUrl(event.properties[key]);
      });
    }
    event.properties.environment = environment;
    event.properties.integration_version = 'softpura-20261104a';
    // The ingestion envelope requires this public project token. Other tokens remain stripped.
    if (projectToken === config.token) event.properties.token = config.token;
    return event;
  }
  function clearBridge() {
    try { window.localStorage.removeItem(BRIDGE); window.sessionStorage.removeItem(FINGERPRINT); } catch (error) {}
  }
  function bridge() {
    if (!sdk || !active || !consent() || suppressBridge) return null;
    try {
      var ids = {
        distinct_id: sdk.get_distinct_id(), session_id: sdk.get_session_id(),
        environment: environment, updated_at: Date.now()
      };
      if (windowId) ids.window_id = windowId;
      var fingerprint = window.sessionStorage.getItem(FINGERPRINT);
      if (/^sp_(contact|shopify)_/.test(ids.distinct_id || '') && /^[a-f0-9]{64}$/.test(fingerprint || '')) ids.contact_fingerprint = fingerprint;
      if (typeof ids.distinct_id !== 'string' || /@/.test(ids.distinct_id) || !ids.session_id) return null;
      window.localStorage.setItem(BRIDGE, JSON.stringify(ids));
      return ids;
    } catch (error) { return null; }
  }
  function safeReplayPage() {
    // Replay metadata includes the document URL. Never record a page containing private query values.
    return !/[?&](?:[^=&#]*(?:email|token|key|password|code|address|auth|access|session|secret|signature|credential|recover)[^=&#]*)=/i.test(window.location.search) &&
      !/@|%40/i.test(window.location.href) &&
      !/\/(checkouts|reset|activate|recover|auth|oauth|token)(?:\/|$)/i.test(window.location.pathname);
  }
  function restoreCheckoutIdentity() {
    if (!sdk || !active || !consent()) return false;
    try {
      var saved = JSON.parse(window.localStorage.getItem(BRIDGE) || 'null');
      if (!saved || saved.environment !== environment || Date.now() - saved.updated_at > 1800000 ||
          saved.updated_at > Date.now() + 60000 || typeof saved.distinct_id !== 'string' ||
          !/^sp_(contact|shopify)_[a-zA-Z0-9-]{12,100}$/.test(saved.distinct_id) ||
          saved.distinct_id === sdk.get_distinct_id()) return false;
      // A checkout contact change can rotate the pixel identity. Never merge its old SDK person.
      var previousSuppression = suppressBridge;
      suppressBridge = true;
      try {
        epoch++;
        identifiedFingerprint = null;
        pendingContacts = [];
        // The bridge is shared across tabs; replace a tab-local fingerprint with its owner's value.
        if (/^[a-f0-9]{64}$/.test(saved.contact_fingerprint || '')) window.sessionStorage.setItem(FINGERPRINT, saved.contact_fingerprint);
        else window.sessionStorage.removeItem(FINGERPRINT);
        sdk.stopSessionRecording();
        sdk.reset(true);
        if (!active || !consent()) return false;
        sdk.opt_in_capturing({ captureEventName: false });
        sdk.identify(saved.distinct_id);
      } finally { suppressBridge = previousSuppression; }
      return true;
    } catch (error) { return false; }
  }
  function enable() {
    if (!sdk || active || !consent()) return;
    active = true;
    // opt-in/reset may synchronously emit onSessionId. Preserve the incoming checkout bridge.
    suppressBridge = true;
    try {
      sdk.opt_in_capturing({ captureEventName: false });
      restoreCheckoutIdentity();
    } finally { suppressBridge = false; }
    sdk.register({ environment: environment, integration_version: 'softpura-20261104a' });
    bridge();
    sdk.capture('$pageview', { $current_url: cleanUrl(window.location.href), $referrer: cleanUrl(document.referrer) });
    sdk.capture('tracking_ready', { source: 'storefront' });
    if (safeReplayPage()) sdk.startSessionRecording();
    if (config.customerId) identifyContact(config.customerEmail, 'customer', 'shopify_customer_' + config.customerId);
    var queued = pending; pending = [];
    queued.forEach(function (args) { capture(args[0], args[1]); });
    var contacts = pendingContacts; pendingContacts = [];
    contacts.forEach(function (args) { identifyContact(args[0], args[1], args[2]); });
  }
  function disable() {
    epoch++;
    pending = [];
    pendingContacts = [];
    windowId = null;
    identifiedFingerprint = null;
    clearBridge();
    if (!sdk) { active = false; return; }
    active = false;
    sdk.stopSessionRecording();
    sdk.opt_out_capturing();
    sdk.reset(true);
  }
  function load() {
    if (loading || sdk) return;
    loading = true;
    // Official async snippet protocol; the SDK is loaded only for permitted storefront traffic.
    var stub = window.posthog = window.posthog || [];
    if (stub.__loaded) { loading = false; return; }
    stub._i = stub._i || [];
    stub.__SV = 1;
    stub.people = stub.people || [];
    ['capture','register','identify','reset','get_distinct_id','get_session_id','opt_in_capturing','opt_out_capturing','startSessionRecording','stopSessionRecording','onSessionId'].forEach(function (method) {
      stub[method] = function () { stub.push([method].concat(Array.prototype.slice.call(arguments))); };
    });
    var options = {
      api_host: config.host.replace(/\/$/, ''), defaults: '2026-08-30',
      person_profiles: 'identified_only', opt_out_capturing_by_default: true,
      capture_pageview: false, capture_pageleave: false, autocapture: false,
      capture_dead_clicks: false, capture_exceptions: false, capture_performance: false,
      disable_session_recording: true, enable_recording_console_log: false,
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: { password: true, text: false, email: false, tel: false, textarea: false, select: false },
        maskTextSelector: '[data-sensitive],.ph-mask',
        blockSelector: 'input[type="password"],input[type="hidden"],[autocomplete="current-password"],[autocomplete="new-password"],[name*="password" i],[id*="password" i],[autocomplete^="cc-"],[autocomplete="one-time-code"],[name*="card" i],[name*="cvv" i],[name*="cvc" i],[name*="security_code" i],[name*="otp" i],a[href*="email" i],a[href*="token" i],[data-sensitive],.ph-no-capture',
        recordHeaders: false, recordBody: false, streamNetworkBody: false, captureJsonLd: false,
        maskCapturedNetworkRequestFn: function (request) {
          request.name = cleanUrl(request.name || '');
          delete request.requestBody; delete request.responseBody;
          delete request.requestHeaders; delete request.responseHeaders;
          return request;
        }
      },
      before_send: beforeSend,
      loaded: function (client) {
        sdk = client; loading = false;
        if (typeof sdk.onSessionId === 'function') sdk.onSessionId(function (session, currentWindow) { windowId = currentWindow || null; bridge(); });
        if (consent()) enable(); else disable();
      }
    };
    stub._i.push([config.token, options, 'posthog']);
    var script = document.createElement('script');
    script.async = true; script.crossOrigin = 'anonymous';
    script.src = config.host.replace(/\/$/, '').replace('.i.posthog.com', '-assets.i.posthog.com') + '/static/array.js';
    script.onerror = function () { loading = false; pending = []; pendingContacts = []; stub._i = []; };
    document.head.appendChild(script);
  }
  function refresh() {
    if (!consent()) { disable(); return; }
    if (sdk) enable(); else load();
  }
  function capture(name, properties) {
    if (!allowedEvents.test(name) || !consent()) return false;
    var props = {};
    Object.keys(properties || {}).forEach(function (key) {
      var value = properties[key];
      if (allowedProps.test(key) && ['string','number','boolean'].indexOf(typeof value) !== -1) props[key] = clean(value, key, false);
    });
    if (!active) { if (pending.length < 30) pending.push([name, props]); refresh(); return false; }
    bridge(); sdk.capture(name, props); return true;
  }
  function identifyContact(email, source, customerId) {
    if (['popup','footer','newsletter','checkout','customer'].indexOf(source) === -1 || !consent()) return Promise.resolve(false);
    email = typeof email === 'string' ? email.trim().toLowerCase() : '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length > 254 || !window.crypto || !window.crypto.subtle) return Promise.resolve(false);
    if (!active) {
      if (pendingContacts.length < 4) pendingContacts.push([email, source, customerId]);
      refresh();
      return Promise.resolve(false);
    }
    var generation = epoch;
    identifying = identifying.catch(function () {}).then(async function () {
      var bytes = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(email));
      var fingerprint = Array.from(new Uint8Array(bytes)).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
      if (generation !== epoch || !active || !consent()) return false;
      var prior;
      try { prior = identifiedFingerprint || window.sessionStorage.getItem(FINGERPRINT); } catch (error) {}
      var currentId = sdk.get_distinct_id();
      if ((prior && prior !== fingerprint) || (!prior && /^sp_(contact|shopify)_|^shopify_customer_/.test(currentId || ''))) {
        var previousSuppression = suppressBridge;
        suppressBridge = true;
        try {
          sdk.stopSessionRecording(); sdk.reset(true);
          if (!active || !consent()) return false;
          sdk.opt_in_capturing({ captureEventName: false });
        } finally { suppressBridge = previousSuppression; }
      }
      identifiedFingerprint = fingerprint;
      try { window.sessionStorage.setItem(FINGERPRINT, fingerprint); } catch (error) {}
      var id = customerId;
      if (!id) {
        var current = sdk.get_distinct_id();
        id = /^sp_contact_[a-f0-9-]+$/.test(current || '') && prior === fingerprint ? current :
          'sp_contact_' + window.crypto.randomUUID();
      }
      sdk.identify(id, { email: email, contact_source: source });
      capture('contact_captured', { source: source }); bridge();
      if (safeReplayPage()) sdk.startSessionRecording();
      return true;
    });
    return identifying;
  }
  window.SoftPuraAnalytics = { capture: capture, identifyContact: identifyContact, getIds: bridge };
  document.addEventListener('cookie:consented', refresh);
  document.addEventListener('visitorConsentCollected', refresh);
  window.addEventListener('storage', function (event) {
    if (event.key === 'sp_cookie_consent') refresh();
    if (event.key === BRIDGE && active && restoreCheckoutIdentity()) {
      bridge();
      if (active && consent() && safeReplayPage()) sdk.startSessionRecording();
    }
  });
  document.addEventListener('sp:analytics', function (event) {
    if (event.detail) capture(event.detail.event, event.detail.properties);
  });
  document.addEventListener('sp:contact-submitted', function (event) {
    if (event.detail) identifyContact(event.detail.email, event.detail.source);
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || typeof form.id !== 'string' || (typeof form.checkValidity === 'function' && !form.checkValidity())) return;
    var source = form.id === 'custom-footer-newsletter-form' ? 'footer' :
      form.id.indexOf('sp-sc-newsletter-form-') === 0 ? 'popup' :
      form.id.indexOf('sp-nb-form-') === 0 ? 'newsletter' : null;
    if (!source) return;
    var input = form.querySelector('input[name="contact[email]"]');
    if (input) identifyContact(input.value, source);
  }, true);
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('#sp-checkout-btn,[name="checkout"]') : null;
    if (target) capture('storefront_checkout_clicked', { source: 'cart' });
  }, true);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], refresh);
  }
  refresh();
})();
